import React, { createContext, useContext, useState } from "react";
import FullPageLoader from "../components/common/FullPageLoader";

const LoadingContext = createContext();

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error("useLoading must be used within LoadingProvider");
  }
  return context;
};

export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("Processing...");

  const showLoading = (msg = "Processing...") => {
    setMessage(msg);
    setLoading(true);
  };

  const hideLoading = () => {
    setLoading(false);
  };

  return (
    <LoadingContext.Provider value={{ showLoading, hideLoading, loading }}>
      {children}
      {loading && <FullPageLoader message={message} />}
    </LoadingContext.Provider>
  );
};

